import * as $ from 'jquery';

import i18next from 'i18next';
import i18CustomParams from 'new_design/common/i18_custom';

import * as textField from '@material/textfield/index';
import 'inputmask';
import DatePicker from 'new_design/common/search_widget/date-picker';
import { tns } from 'tiny-slider/src/tiny-slider';
import { horizontalDragScroll } from '../common/horizontal_drag_scroll';
import { showBtnFor } from '../new_design/common/payment/btn-toggle';
import GuestsWidgetMobile from '../new_design/mobile/common/search_widget/guests_mobile';
import { isEmailValid } from '/app/assets/javascripts/common/validation';
import {
  iti_config,
  phone_settings,
  safeInitIntlTelInput,
} from '/app/assets/javascripts/new_design/common/intl_tel_input_config.js';

import { initFixedHeader } from './lib/fixed_header';
import { initSlider } from './lib/main_slider';
import { initPhoneClickLogging } from './modules/phone_click_logging';

$(function () {
  window.website_prefix = $('body').data('domain');

  i18next.init(i18CustomParams(), function (err, t) {});

  // Инициализируем логирование кликов по телефону
  initPhoneClickLogging();

  let datePicker = new DatePicker('search-form-apartments', {
    dateStart: '#apartments_date_start',
    dateEnd: '#apartments_date_end',
    dateRange: '.apartments_dates',
    nightsCount: '#apartments_nights_count',
    isBookingByDay: $("input[name='is_booking_by_day']").val() === 'true',
    firstPreview: false,
    campId: $("input[name='camp_id']").val(),
    pricesDomain: 'https://kurortix.ru',
    additionalOpen: '.no-date__link',
    onUpdate: () => {
      updateApartments();
      goToApartments('apartments');
    },
  });

  window.datePicker = datePicker;

  datePicker.init();

  let bigDatePicker = new DatePicker('search-form-main', {
    dateStart: '#apartments_date_start',
    dateEnd: '#apartments_date_end',
    dateRange: '.search-form-main-dates',
    nightsCount: '#apartments_nights_count',
    isBookingByDay: $("input[name='is_booking_by_day']").val() === 'true',
    firstPreview: false,
    pricesDomain: 'https://kurortix.ru',
    campId: $("input[name='camp_id']").val(),
    onUpdate: () => {},
  });

  bigDatePicker.init();

  const mainDatePicker = new DatePicker('dates', {
    dateStart: '#date_start',
    dateEnd: '#date_end',
    dateRange: '#date_range',
    firstPreview: false,
    widget: true,
  });

  mainDatePicker.init();

  if ($('#apartments-list').length === 0) {
    let guestsWidget = new GuestsWidgetMobile('#search-guest', {
      childrenAges: '.children_ages',
      childrenCount: '.children_count',
      countGuests: '.count_guests',
      guestChildNumber: '.guest-child-number',
      totalAdultsCount: '.total_adults_count',
      totalChildrenCount: '.total_children_count',
      doInitPopupOpen: false,
      afterChildInputCreate: () => {
        $('#search-guest .guest-child__input-item').click(handleChildItemClick);
      },
    });

    guestsWidget.init();

    let mainGuestsWidget = new GuestsWidgetMobile('#main_search-guest', {
      childrenAges: '.main_children_ages',
      childrenCount: '.main_children_count',
      countGuests: '.main_count_guests',
      guestChildNumber: '.main_guest-child-number',
      totalAdultsCount: '.main_total_adults_count',
      totalChildrenCount: '.main_total_children_count',
      doInitPopupOpen: false,
      afterChildInputCreate: () => {
        $('#main_search-guest .guest-child__input-item').click(handleMainChildItemClick);
      },
    });

    mainGuestsWidget.init();
  } else if ($('#search-form-apartments').length > 0) {
    let guestsWidget = new GuestsWidgetMobile('#search-form-apartments', {
      childrenAges: '.children_ages',
      childrenCount: '.children_count',
      countGuests: '.count_guests',
      guestChildNumber: '.guest-child-number',
      totalAdultsCount: '.total_adults_count',
      totalChildrenCount: '.total_children_count',
      doInitPopupOpen: false,
      afterChildInputCreate: () => {
        $('#search-guest .guest-child__input-item').click(handleChildItemClick);
      },
    });

    guestsWidget.init();
  }

  $('.camp-faq__title').click(function () {
    let $wrapper = $(this).closest('.camp-faq__wrapper');
    if ($wrapper.hasClass('opened')) {
      $wrapper.removeClass('opened');
      $wrapper.find('.camp-faq__content').slideUp(200);
    } else {
      $wrapper.addClass('opened');
      $wrapper.find('.camp-faq__content').slideDown(200);
    }
  });

  $('.mdc-text-field').each(function (i, obj) {
    textField.MDCTextField.attachTo(obj);
  });
  $('.mdc-text-field-character-counter').each(function (i, obj) {
    textField.MDCTextFieldCharacterCounter.attachTo(obj);
  });
  $('.mdc-text-field__resizer .mdc-text-field__input')
    .each(function () {
      this.setAttribute('style', 'height:' + (this.scrollHeight || 36) + 'px;overflow-y:hidden;');
    })
    .on('input', function () {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });

  $('#real_arrival_select').click(function () {
    $('#real_arrival_camp_site').fadeIn(200);
  });
  $('#real_arrival_camp_site .input-popup-down__select').click(function () {
    $('#real_arrival_input').val($(this).attr('value'));
    $('#real_arrival_select .ui-select__value').html($(this).attr('value'));
  });

  const dropdownList = $('.header__navigation-dropdown-icon__list')[0];

  $('body').click(function (e) {
    if ($(e.target).closest('#real_arrival_select').length === 0) {
      $('#real_arrival_camp_site').fadeOut(200, () => {
        let index = window.openedPopupsIdsStack.indexOf('#real_arrival_camp_site');
        if (index > -1) {
          window.openedPopupsIdsStack.splice(index, 1);
        }
      });
    }
    if (
      $(e.target).closest('.header__navigation-dropdown-icon__list').length === 0 &&
      $(e.target).closest('.header__navigation-dropdown-icon').length === 0
    ) {
      dropdownList?.classList?.add('header__navigation-dropdown-icon__list__hidden');
    }
  });

  $('.apartments-search-params__guests').click(function () {
    $('#search-guest').fadeIn(200);
  });

  $('#search-form-main .search-params__submit').click(function () {
    goToApartments('main');
  });

  $('.guests-modal__btn').click(function (e) {
    goToApartments();
  });

  const guestsWrapperSelector =
    '#search-form-main .search-params__guests-wrapper, #search-form-main .search-widget__guests-picker-wrapper';
  $(guestsWrapperSelector).click(function () {
    $('#main_search-guest').fadeIn(200);
  });

  $('.search-form-main-dates').click(() => {
    $('#main_search-guest').fadeOut(200);
  });
  $('body').click(function (e) {
    if (
      $(e.target).closest('.search-params__guests-wrapper').length === 0 &&
      $(e.target).closest('.search-widget__guests-picker-wrapper').length === 0 &&
      $(e.target).closest('.guests-modal__wrapper').length === 0
    ) {
      $('#main_search-guest').fadeOut(200);
    }
  });

  $('body').click(function (e) {
    if (
      $(e.target).closest('.apartments-search-params__guests').length === 0 &&
      $(e.target).closest('.guests-modal__wrapper').length === 0
    ) {
      $('#search-guest').fadeOut(200);
    }
  });
  if ($(window).width() > 768) {
    $('#count_guests').change(function () {
      updateApartments();
      goToApartments('apartments');
    });
    $('#children_count').change(function () {
      updateApartments();
      goToApartments('apartments');
    });
    $('#guest-child-number .popup-select__item').click(function () {
      updateApartments();
      goToApartments('apartments');
    });
  }

  $('.change-dates-btn').click((e) => {
    $('[id^="apartment-modal-"]').hide();
    window.datePicker.open();
    e.stopPropagation();
  });

  $('.guests-modal__back').click(function (e) {
    $('#search-guest, #main_search-guest').fadeOut(200);
    e.stopPropagation();
    updateApartments('apartments');
  });

  $('.guests-modal__btn').click(function (e) {
    $('#search-guest, #main_search-guest').fadeOut(200);
    updateApartments('apartments');
    e.stopPropagation();
  });

  $('body').click(function (e) {
    if ($(e.target).closest('.guest-child__input-item').length === 0) {
      $('#guest-child-number').fadeOut(200);
    }
  });

  $('#search-guest .popup-select__item').click(function () {
    $('#guest-child-number').fadeOut(200);
  });

  $('#main_search-guest .popup-select__item').click(function () {
    $('#main_guest-child-number').fadeOut(200);
  });

  function handleChildItemClick() {
    $('#guest-child-number').fadeIn(200);
    $('#guest-child-number').css('top', $(this).position().top + 48);
    $('#search-guest .guest-child__input-item.activated').removeClass('activated');
    $(this).addClass('activated');
  }

  $('#search-guest .guest-child__input-item').click(handleChildItemClick);

  function handleMainChildItemClick() {
    $('#main_guest-child-number').fadeIn(200);
    $('#main_guest-child-number').css('top', $(this).position().top + 48);
    $('#main_search-guest .main_guest-child__input-item.activated').removeClass('activated');
    $(this).addClass('activated');
  }

  $('#main_search-guest .guest-child__input-item').click(handleMainChildItemClick);

  $('.header__mobile-menu, .header__navigation-menu-btn').click(function () {
    $('.mobile-menu').fadeIn(200);
  });

  $('.mobile-menu__item_with-children').click(function (e) {
    if (!$(this).hasClass('opened')) {
      $(this).find('.mobile-menu__sub-list').toggle();
      $(this).addClass('opened');
      e.preventDefault();
    }
  });

  $('.mobile-menu__back').click(function () {
    $('.mobile-menu').fadeOut(200);
  });

  $('.mobile-menu').click(function (e) {
    if ($(e.target).closest('.mobile-menu__wrapper').length === 0) {
      $('.mobile-menu').fadeOut(200);
    }
  });

  function initModals() {
    $('.open-tariff-modal').click(function () {
      $(`#tariff-modal-${$(this).data('id')}`).fadeIn(200);
      $('html, body').css('overflow', 'hidden');
    });

    $('.tariff-modal__back').click(function () {
      $('.tariff-modal').fadeOut(200);
      $('html, body').css('overflow', 'auto');
    });

    $('.tariff-modal').click(function (e) {
      if ($(e.target).closest('.tariff-modal__wrapper').length === 0) {
        $('.tariff-modal').fadeOut(200);
        $('html, body').css('overflow', 'auto');
      }
    });

    $('.apartment-modal .open-tariff-modal').click(function () {
      $('.apartment-modal').fadeOut(0);
    });

    $('.apartment-modal-open').click(function () {
      $(`#apartment-modal-${$(this).data('id')}`).fadeIn(200);
      $('html, body').css('overflow', 'hidden');
    });

    $('.apartment-modal__back').click(function () {
      $('.apartment-modal').fadeOut(200);
      $('html, body').css('overflow', 'auto');
    });
    $('.apartment-modal').click(function (e) {
      if ($(e.target).closest('.apartment-modal__wrapper').length === 0) {
        $('.apartment-modal').fadeOut(200);
        $('html, body').css('overflow', 'auto');
      }
    });

    $('.apartment-modal__tab').click(function () {
      let $tabs = $(this).parent().find('.apartment-modal__tab');
      let index = $tabs.index($(this));
      $tabs.removeClass('apartment-modal__tab-active');
      $(this).addClass('apartment-modal__tab-active');
      $(this).parent().parent().find('.apartment-modal__tabs-content').fadeOut(200);
      $(this).parent().parent().find('.apartment-modal__tabs-content').eq(index).fadeIn(200);
    });

    $('.page-apartment__tariff-btn').click(function () {
      let $wraper = $(this).closest('.apartment-modal__inner-wrapper');
      let $tabs = $wraper.find('.apartment-modal__tab');
      $tabs.removeClass('apartment-modal__tab-active');
      $tabs.eq(0).addClass('apartment-modal__tab-active');
      $wraper.find('.apartment-modal__tabs-content').fadeOut(200);
      $wraper.find('.apartment-modal__tabs-content').eq(0).fadeIn(200);
      $wraper.scrollTop(400);
    });
  }

  initModals();

  function updateApartments() {
    if ($('#apartments-list').length > 0) {
      let base_url = $('#apartments-list').data('url');
      let date_start = $('#apartments_date_start').val();
      let date_end = $('#apartments_date_end').val();
      let children_ages = []; //$('#apartments_children_ages').val();
      $('#children_ages input[name="children_ages[]"]').each(function (i, elem) {
        children_ages.push($(elem).val());
      });
      let count_guests = $('#count_guests').val();
      let url = `${base_url}?date_start=${date_start}&date_end=${date_end}&children_ages=${children_ages}&count_guests=${count_guests};`;
      $('#apartments-loading').show();
      $('#apartments-list').hide();
      if (window.apartments_request) window.apartments_request.abort();
      window.apartments_request = $.get(url, function (data) {
        $('#apartments-list').html(data);
        $('#apartments-loading').hide();
        $('#apartments-list').show();
        initModals();
        initSliders();
        $('.change-dates-btn').click((e) => {
          window.datePicker.open();
          e.stopPropagation();
        });
        window.apartments_request = null;
      });
    }
  }

  function goToApartments(form) {
    if ($('#apartments-list').length === 0) {
      let date_start;
      let date_end;
      let count_guests;
      let children_ages = [];
      if (form === 'main') {
        date_start = $('#search-form-main #apartments_date_start').val();
        date_end = $('#search-form-main #apartments_date_end').val();
        count_guests = $('#search-form-main #main_count_guests').val();
        $('#main_children_ages input[name="children_ages[]"]').each(function (i, elem) {
          children_ages.push($(elem).val());
        });
      } else {
        date_start = $('#apartments_date_start').val();
        date_end = $('#apartments_date_end').val();
        count_guests = $('#search-form-apartments #count_guests').val();
        $('#children_ages input[name="children_ages[]"]').each(function (i, elem) {
          children_ages.push($(elem).val());
        });
      }

      const urlParams = new URLSearchParams(window.location.search);

      urlParams.set('date_start', date_start);
      urlParams.set('date_end', date_end);
      urlParams.set('count_guests', count_guests);
      urlParams.set('children_ages', children_ages);

      window.location.href = `${window.website_prefix}/apartments?${urlParams}`;
    }
  }

  function initSliders() {
    let $sliderWraps = $('.slider-tns__wrap');
    $sliderWraps.each(function () {
      let $wrap = $(this);
      let $slider = $wrap.find('.slider-tns');
      let $controls = $wrap.find('.slider-tns__arrows');
      let items = $wrap.data('items') || 1;
      items = parseInt(items);
      if (items > 2 && $(window).width() < 1024) {
        items = 2;
      }
      if (items > 1 && $(window).width() < 768) {
        items = 1;
      }

      let sliderTns = tns({
        container: $slider[0],
        items: items,
        center: false,
        gutter: 12,
        loop: false,
        rewind: false,
        nav: true,
        controlsContainer: $controls[0],
        preventScrollOnTouch: 'auto',
        lazyload: true,
      });

      if (!sliderTns) return; // на случай, если изображений нет

      sliderTns.events.on('indexChanged', (info) => {
        let { index } = info;
        $controls.find('.mobile_slider_arrow_wrapper-left').toggle(index !== 0);
      });
    });
  }

  initSliders();

  $('#booking-user-phone').parent().find('.mdc-floating-label').addClass('mdc-floating-label--float-above');

  $('.main-form-pay-method').on('click', function () {
    $('.main-form-pay-method-selected').removeClass('main-form-pay-method-selected');
    $(this).addClass('main-form-pay-method-selected');
    showBtnFor(this);
  });
  $('.main-form-pay-method:first').trigger('click');

  if ($(window).width() > 768 && $('.services__wrapper').length > 0) {
    horizontalDragScroll($('.services__wrapper')[0]);
  }

  $('.treatment-profile-page__procedures-text table').each(function () {
    $(this).wrap('<div class="treatment-profile-page__procedures-table"></div>');
    $(this).wrap('<div class="treatment-profile-page__procedures-scrollable-table"></div>');
    $(this).parent().parent().append('<table></table>');
    let $new_table = $(this).parent().parent().find('table').eq(1);
    $new_table.wrap('<div class="treatment-profile-page__procedures-fake-table"></div>');
    $(this)
      .find('tr')
      .each(function () {
        $new_table.append('<tr></tr>');
        let new_tr = $new_table.find('tr:last-child');
        new_tr.append($(this).find('th, td').eq(0).clone());
      });
  });

  $('#payment-btn').click(function () {
    window.ymReachGoal('oplatit');
  });

  $('.header__navigation-dropdown-icon').click(() => {
    dropdownList.classList.toggle('header__navigation-dropdown-icon__list__hidden');
  });

  initFixedHeader();
  initSlider();

  initPopupWidget();

  const forms = $('.widget__form');
  const formCallback = $('.callback-form__container');
  setFormValidatorCallback(formCallback);

  forms.each(function () {
    const form = $(this);
    setFormValidator(form);
  });
});

function initPopupWidget() {
  const elements = {
    callbackIco: $('.widget__callback_ico'),
    callbackClose: $('.widget__callback_close'),
    callbackIcoWhatsapp: $('.widget__watsapp_ico'),
    callbackCloseWhatsapp: $('.widget__watsapp_close'),
    overlay: $('.overlay'),
    popupBidsOpen: $('.popup-bids_open'),
    callbackFormContainer: $('.callback-form'),
    callbackForm: $('#callback-form'),
    overlayBids: $('.overlay-bids'),
    successMessage: $('#success-message'),
    submitBtns: $('.widget__submit'),
    callbackSubmitBtn: $('#callback_submit'),
    callbackFormContacts: $('.callback-form__contacts'),
    callbackFormInputLabel: $('.callback-form__input-label'),
    widget__container: $('.widget__container'),
    callbackLoader: $('.callback-form__loader'),
  };

  //скрываеем и показываем блок с виджетами при скролле
  function toggleWidget() {
    if ($(window).scrollTop() > 120) {
      elements.widget__container.show();
    } else {
      elements.widget__container.hide();
    }
  }

  if ($(window).width() <= 768) {
    toggleWidget();

    $(window).on('scroll', function () {
      toggleWidget();
    });
  }

  elements.callbackIco.on('click', function () {
    elements.callbackFormContainer.toggle();
    elements.overlayBids.addClass('overlay-bids_open');
    elements.callbackFormContacts.show();
    elements.callbackFormInputLabel.show();

    $('html, body').css('overflow', 'hidden');
  });

  const closeForm = () => {
    elements.popupBidsOpen.hide();
    if (elements.callbackFormContainer.css('display') === 'block') {
      elements.callbackFormContainer.toggle();
    }

    $('html, body').css({
      'overflow-x': 'hidden',
      'overflow-y': 'auto',
    });
    //Нужно для запрета прокрутки на айфоне
    $('body').css({
      position: 'relative',
      'max-width': '100%',
    });

    elements.overlayBids.removeClass('overlay-bids_open');
    elements.successMessage.hide();
    elements.callbackFormContacts.hide();
    elements.callbackFormInputLabel.show();
  };

  $('.callback-form__close, .callback-form__success_button, .popup-bids__link, .overlay-bids').on(
    'click',
    function (event) {
      // Проверяем, что клик был именно по подложке, а не по её дочерним элементам
      if ($(this).hasClass('overlay-bids') && event.target !== this) return;
      closeForm();
    }
  );

  const toggleCloseWidth = (element, width) => element.css('width', width);

  elements.callbackIco
    .on('mouseover', function () {
      elements.callbackClose.css('width', '175px');
      elements.callbackClose.css('padding', '11px 0 11px 16px');
    })
    .on('mouseout', function () {
      toggleCloseWidth(elements.callbackClose, '0');
      elements.callbackClose.css('width', '0');
      elements.callbackClose.css('padding', '0');
    });

  elements.callbackIcoWhatsapp
    .on('mouseover', function () {
      elements.callbackCloseWhatsapp.css('width', '155px');
      elements.callbackCloseWhatsapp.css('padding', '11px 0 11px 16px');
    })
    .on('mouseout', function () {
      elements.callbackCloseWhatsapp.css('width', '0');
      elements.callbackCloseWhatsapp.css('padding', '0');
    });

  elements.callbackIco.on('click', function () {
    elements.overlay.css('display', 'block');
  });

  $('.callback-form__bid_button').on('click', function () {
    elements.callbackFormContainer.toggle();
    elements.popupBidsOpen.toggle();
    new DatePicker('dates-popup', {
      dateStart: '#date_start-popup',
      dateEnd: '#date_end-popup',
      dateRange: '#date_range-popup',
      firstPreview: false,
      widget: true,
    }).init();
  });

  $('.callback-form__input')
    .on('focus', function () {
      $(this).siblings('.callback-form__input-label').hide();
    })
    .on('blur', function () {
      if ($(this).val() === '') {
        $(this).siblings('.callback-form__input-label').show();
      }
    });

  const sendRequestWidget = (form) => {
    const loader = form.find('.widget__submit_loader');
    const submitText = form.find('.widget__submit-text');
    const formData = new FormData(form[0]);
    loader.removeClass('hidden');
    submitText.hide();
    formData.set("captcha_token", document.getElementsByName('smart-token')[0].value);

    fetch(form[0].action, {
      method: form[0].method,
      body: formData,
    })
      .then((res) => {
        if (res.ok) {
          elements.overlayBids.addClass('overlay-bids_open');
          elements.popupBidsOpen.hide();
          elements.callbackFormContacts.hide();
          elements.callbackFormContainer.toggle();
          elements.successMessage.css('display', 'flex');
        } else {
          throw new Error('Не удалось выполнить запрос, попробуйте через пару минут');
        }
      })
      .catch((er) => {
        alert(er);
      })
      .finally(() => {
        loader.addClass('hidden');
        submitText.show();
        form[0].reset();
        elements.submitBtns.addClass('disabled');
        elements.submitBtns.attr('disabled', 'true');
      });
  };
  // Инициализируем каждую форму
  elements.submitBtns.each(function () {
    const submitBtn = $(this);
    const popup = submitBtn.data('popup');
    const formId = popup ? '#widget__form-popup' : '#widget__form';
    const form = $(formId);

    form.on('submit', function (e) {
      e.preventDefault();

      if (!window.smartCaptcha) {
        return;
      }

      window.passedCaptcha = function () {
        sendRequestWidget(form);
      }
      window.smartCaptcha.execute();
    });
  });

  const submitCallback = elements.callbackSubmitBtn;

  elements.callbackForm.on('submit', function (event) {
    event.preventDefault();
    const formData = {
      name: $('#input-name').val(),
      call: {
        name: $('#input-name').val(),
        number: $('#number-callback').val(),
        callable_id: submitCallback.data('callableId'),
        callable_type: submitCallback.data('callableType'),
      },
      book: {
        camp_id: $('#camp_id').val(),
        camp_site: $('#camp_site').val(),
      },
      client: {
        name: $('#input-name').val(),
        phone_number: $('#number-callback').val(),
      },
      sales_channel_id: submitCallback.data('salesChannelId'),
      website_type: submitCallback.data('websiteType'),
      camp_site_id: submitCallback.data('campSiteId'),
      widget_type: $('#widget_type').val(),
    };

    submitCallback.hide();
    elements.callbackLoader.show();

    fetch('/bids/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((res) => {
        if (res.ok) {
          elements.callbackFormContacts.toggle();
          elements.successMessage.css('display', 'flex');
        } else {
          throw error;
        }
      })
      .catch((er) => {
        alert('Произошла ошибка, попробуйте через пару минут');
      })
      .finally(() => {
        elements.callbackLoader.hide();
        submitCallback.show();
        elements.callbackForm[0].reset();
      });
  });
}

function setFormValidator(form) {
  const requiredFields = form.find('.required-field input');
  const submitButton = form.find('.widget__submit');
  const emailInput = form.find('.widget-email input');
  const phoneInput = form.find('.widget-phone input');
  const exp = initTelInput(form);

  let phoneTouched = false; // флаг, отмечающий, было ли затронуто поле телефона

  // Проверка обязательных полей
  function checkRequiredFields() {
    let allFilled = true;
    requiredFields.each(function () {
      let value = $(this).val().trim();
      if (value === '' || /[a-zA-Z]/.test(value)) {
        $(this).addClass('input-error');
        $(this).parent().addClass('input-error-wrapper');
        allFilled = false;
      } else {
        $(this).removeClass('input-error');
        $(this).parent().removeClass('input-error-wrapper');
      }
    });
    return allFilled;
  }

  // Проверка email
  function checkEmail() {
    if (!isEmailValid(emailInput) && emailInput.val().trim() !== '') {
      emailInput.addClass('input-error');
      return false;
    }
    emailInput.removeClass('input-error');
    return true;
  }

  // Проверка телефона
  function checkPhone() {
    if (!exp.test(phoneInput.val().trim())) {
      phoneInput.addClass('input-error');
      return false;
    }
    phoneInput.removeClass('input-error');
    return true;
  }

  // Финальная проверка всех полей перед активацией кнопки
  function validateFormFields() {
    const allFieldsValid = checkRequiredFields() && checkPhone() && checkEmail();

    if (allFieldsValid) {
      submitButton.removeClass('widget__submit_disabled');
      submitButton.removeAttr('disabled');
    } else {
      submitButton.addClass('widget__submit_disabled');
      submitButton.attr('disabled', 'true');
    }
  }

  // Добавляем обработчики событий
  requiredFields.on('input', function () {
    validateFormFields();
  });

  emailInput.on('blur', function () {
    validateFormFields();
  });

  phoneInput.on('blur', function () {
    phoneTouched = true;
    validateFormFields();
  });
}

function setFormValidatorCallback(form) {
  const nameInput = form.find('.name-callback input');
  const phoneInput = form.find('.phone-callback input');
  const submitButton = form.find('#callback_submit');
  const exp = initTelInput(form);

  function checkPhone() {
    if (!exp.test(phoneInput.val().trim())) {
      phoneInput.addClass('input-error');
      return false;
    } else {
      phoneInput.removeClass('input-error');
      return true;
    }
  }

  function checkName() {
    if (nameInput.val().trim() === '') {
      nameInput.addClass('input-error');
      return false;
    } else {
      nameInput.removeClass('widget-field__error');
      return true;
    }
  }

  submitButton.on('click', function (event) {
    event.preventDefault();
    if (checkName() && checkPhone()) {
      form.submit();
    }
  });
}

function initTelInput(form) {
  const phoneInput = form.find('.widget-phone input');
  const iti = safeInitIntlTelInput(`#${phoneInput.attr('id')}`, iti_config);

  return phone_settings[iti.getSelectedCountryData().iso2]['validator'];
}
